var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F5F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 21.5H18.5C15.4375 21.5 13 23.9688 13 27C13 27.5625 13.4375 28 14 28H26C26.5312 28 27 27.5625 27 27C27 23.9688 24.5312 21.5 21.5 21.5ZM14.5 26.5C14.75 24.5312 16.4375 23 18.5 23H21.5C23.5312 23 25.2188 24.5312 25.4688 26.5H14.5ZM20 20C22.1875 20 24 18.2188 24 16C24 13.8125 22.1875 12 20 12C17.7812 12 16 13.8125 16 16C16 18.2188 17.7812 20 20 20ZM20 13.5C21.375 13.5 22.5 14.625 22.5 16C22.5 17.4062 21.375 18.5 20 18.5C18.5938 18.5 17.5 17.4062 17.5 16C17.5 14.625 18.5938 13.5 20 13.5Z",
    fill: "#464B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconMob);
export default __webpack_public_path__ + "static/media/UserIconMob.434c85d716ca75bee6d0caf1ae2b0c6c.svg";
export { ForwardRef as ReactComponent };